import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AntProgress from "antd/es/progress";
const Progress = (props) => {
    const { className, percent } = props;
    let cls = "";
    if (percent >= 50) {
        cls = " secondary-color";
    }
    if (percent >= 100) {
        cls = " status-success";
    }
    const classes = classNames("gerudo-progress", cls, className);
    return React.createElement(AntProgress, Object.assign({ className: classes }, props));
};
Progress.defaultProps = {
    showInfo: false,
    type: "circle",
    strokeWidth: 16,
    width: 48,
};
Progress.propTypes = {
    format: PropTypes.func,
    percent: PropTypes.number,
    showInfo: PropTypes.bool,
    status: PropTypes.oneOf(["success", "exception", "normal", "active"]),
    strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    success: PropTypes.arrayOf(PropTypes.shape({
        percent: PropTypes.number,
        strokeColor: PropTypes.string,
    })),
    type: PropTypes.oneOf(["circle", "line", "dashboard"]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
export default Progress;
export { Progress };
//# sourceMappingURL=index.js.map